import { OPEN_HAMBURGER_MENU, OPEN_SEARCHBAR, CLOSE_SEARCHBAR, MEMBER_UPDATED, SUBSCRIBER_METADATA_UPDATED, IS_OPEN_LOGIN_FORM, AUTH_INITIALIZATION_STARTED, AUTH_INITIALIZATION_COMPLETED, MOBILE_MENU_TOGGLED } from "./actions";

function hamburgerMenuReducer(state = false, action) {
  switch (action.type) {
    case OPEN_HAMBURGER_MENU:
      return action.isHamburgerMenuOpen;
    default:
      return state;
  }
}

function searchBarReducer(state = false, action) {
  switch (action.type) {
    case OPEN_SEARCHBAR:
      return action.isSearchBarOpen;
    case CLOSE_SEARCHBAR:
      return action.isSearchBarOpen;
    default:
      return state;
  }
}

function memberReducer(state = null, action) {
  switch (action.type) {
    case MEMBER_UPDATED:
      return action.member;

    default:
      return state;
  }
}

function loginReducer(state = false, action) {
  switch (action.type) {
    case IS_OPEN_LOGIN_FORM:
      return action.payload;
    default:
      return state;
  }
}

const userIntialState = {
  jwt_token: null,
};

function userReducer(state = userIntialState, action) {
  switch (action.type) {
    case "METYPE_JWT_TOKEN":
      return {
        ...state,
        jwt_token: action.payload,
      };

    default:
      return state;
  }
}

function subscriberMetadataReducer(state = null, action) {
  switch (action.type) {
    case SUBSCRIBER_METADATA_UPDATED:
      return action.metadata;

    default:
      return state;
  }
}

function authInitializationReducer(state = false, action) {
  switch (action.type) {
    case AUTH_INITIALIZATION_STARTED:
      return true;
    case AUTH_INITIALIZATION_COMPLETED:
      return false;

    default:
      return state;
  }
}

function mobileMenuReducer(state = false, action) {
  switch (action.type) {
    case MOBILE_MENU_TOGGLED:
      return action.isOpen;

    default:
      return state;
  }
}

export const REDUCERS = {
  isHamburgerMenuOpen: hamburgerMenuReducer,
  isSearchBarOpen: searchBarReducer,
  member: memberReducer,
  subscriberMetadata: subscriberMetadataReducer,
  isLoginOpen: loginReducer,
  userReducer: userReducer,
  isAuthInitializing: authInitializationReducer,
  isMobileMenuOpen: mobileMenuReducer,
};
